module.exports = __webpack_public_path__ + "static/img-7-84d8aad1f251a6a4d9f76e776e6c9f3c.jpeg";